import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import OneResource from "./OneResource";
import Filter from "./Filter";

export default function ReportsBanner() {
  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);
  const [filter, setFilter] = useState("");

  async function init() {
    setReady(false);
    await Promise.all([appContext.getAllReports()]);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    const reports = appContext.allReports || [];
    const filteredReports = reports.filter((item) =>
      item.title.toLowerCase().includes(filter.toLowerCase()),
    );

    return (
      <>
        <Filter filter={filter} setFilter={setFilter} />
        {filter && filter.trim().length > 0 && (
          <div className="col-md-12 text-center mb-4">
            <h6 className="font-light" style={{ fontSize: "18px" }}>
              Search Results For:{" "}
              <span className="font-semi-bold">{filter}</span>
            </h6>
          </div>
        )}
        <div className="row">
          {filteredReports.length > 0 ? (
            filteredReports.map((item) => (
              <div key={item.uuid} className="col-12 col-md-6">
                <OneResource data={item} />
              </div>
            ))
          ) : (
            <div className="col-12">
              <p>
                {filter
                  ? "No matching reports found."
                  : "No reports available."}
              </p>
            </div>
          )}
        </div>
      </>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
